import type { CatalogQuery, Service, VendorChoice } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
import { activeOrganizationIdIfAny } from "@/lib/active-organization";
import { api } from "@/lib/api";
import { createCatalogReads, type ServiceChoice } from "@/lib/catalog-reads";

const catalog = createCatalogReads(api.services);

const inActiveOrganization = () => ({ actingOrganization: activeOrganizationIdIfAny() });

export const CatalogRepository = {
  every: (query: CatalogQuery = {}): Promise<Service[]> => catalog.every({ ...inActiveOrganization(), ...query }),

  parentNames: (vendor?: uuid): Promise<string[]> => catalog.parentNames({ ...inActiveOrganization(), vendor }),

  vendorsUnder: (parentName: string): Promise<VendorChoice[]> => catalog.vendorsUnder(parentName, inActiveOrganization()),

  servicesUnder: (vendor: uuid, parentName: string): Promise<ServiceChoice[]> => catalog.servicesUnder(vendor, parentName, inActiveOrganization()),

  parentsOf: (vendor: uuid): Promise<Service[]> => catalog.parentsOf(vendor, inActiveOrganization()),
};
